<template>
  <TsCard
    :data-testid="props.dataTestid + '-nearby-branches-filter-by-radius-card'"
    no-shadow
    no-border
    append-class="w-full rounded-b-xl rounded-t-none bg-natural-soft-white p-3"
  >
    <TsTypography
      as="p"
      :data-testid="props.dataTestid + '-title'"
      append-class="text-sm font-semibold text-idle-black mb-3"
      >{{
        useTranslation(
          'showBranchesNearMyLocation',
          'Toon vestigingen in de buurt van mijn huidige locatie'
        )
      }}
      &nbsp;
      <span
        class="text-primary"
        :data-testid="props.dataTestid + '-radius-filter-reset'"
        @click="emit('reset')"
      >
        (<span class="hover:underline cursor-pointer">{{
          useTranslation('reset', 'opnieuw instellen')
        }}</span
        >)
      </span>
      <span
        v-if="props.errorMessage"
        class="text-xs text-danger font-medium"
        :data-testid="props.dataTestid + '-radius-filter-error-message'"
        >({{ props.errorMessage }})</span
      >
    </TsTypography>

    <div
      class="flex gap-x-3.5 gap-y-2 items-center md:flex-wrap max-md:overflow-x-auto max-md:hide-scroll-bar"
    >
      <TsButton
        v-for="r in props.radiusDetails"
        :key="r.radius"
        :label="`${r.radius} Km`"
        size="sm"
        rounded
        :append-class="
          twMerge(baseButtonClasses, selectedRadius === r.radius && 'text-white bg-primary')
        "
        :data-testid="
          props.dataTestid
            ? props.dataTestid + `-radius-selection-button-for-${r.radius}km`
            : `-radius-selection-button-for-${r.radius}`
        "
        :disabled="r.disabled"
        @click="handleRadiusSelection(r.radius)"
      />
    </div>
  </TsCard>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge';

const TsCard = defineAsyncComponent(() => import('~/components/organisms/TsCard.vue'));

export type RadiusSelection = {
  radius: number;
  disabled?: boolean;
};

const selectedRadius = defineModel<number>('radius');

type Props = {
  radiusDetails?: RadiusSelection[];
  errorMessage?: string;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  radiusDetails: () => [
    {
      radius: 5,
      disabled: false,
    },
    {
      radius: 10,
      disabled: false,
    },
    {
      radius: 15,
      disabled: false,
    },
    {
      radius: 20,
      disabled: false,
    },
  ],
  errorMessage: '',
});

const emit = defineEmits<{
  click: [r: number];
  reset: any;
}>();

function handleRadiusSelection(radius: number) {
  selectedRadius.value = radius;
  emit('click', radius);
}

defineOptions({
  inheritAttrs: false,
});

const baseButtonClasses =
  'whitespace-nowrap bg-white border border-gray transition-colors text-primary px-8 py-2 focus:text-white focus:bg-primary font-semibold focus:ring-0 hover:text-white disabled:!text-natural-silver-grey';
</script>
